import React from 'react';
import { useTranslation } from 'react-i18next';
import './Portfolio2D.css';

interface PortfolioChooserProps {
  onChoose: (view: '3d' | '2d') => void;
}

function PortfolioChooser({ onChoose }: PortfolioChooserProps) {
  const { t } = useTranslation();

  return (
    <div className="chooser">
      <div className="chooser-inner">
        <h1 className="chooser-title">{t('portfolioChooser.title')}</h1>
        <p className="chooser-subtitle">{t('portfolioChooser.subtitle')}</p>

        <div className="chooser-cards">
          <button
            type="button"
            className="chooser-card chooser-card-3d"
            onClick={() => onChoose('3d')}
          >
            <span className="chooser-icon" aria-hidden="true">🕹️</span>
            <span className="chooser-card-title">{t('portfolioChooser.option3d.title')}</span>
            <span className="chooser-card-desc">{t('portfolioChooser.option3d.description')}</span>
            <span className="chooser-enter">{t('portfolioChooser.enter')} ▶</span>
          </button>

          <button
            type="button"
            className="chooser-card chooser-card-2d"
            onClick={() => onChoose('2d')}
          >
            <span className="chooser-icon" aria-hidden="true">👾</span>
            <span className="chooser-card-title">{t('portfolioChooser.option2d.title')}</span>
            <span className="chooser-card-desc">{t('portfolioChooser.option2d.description')}</span>
            <span className="chooser-enter">{t('portfolioChooser.enter')} ▶</span>
          </button>
        </div>

        <p className="chooser-hint">{t('portfolioChooser.hint')}</p>
      </div>
    </div>
  );
}

export default PortfolioChooser;
